export default "__VITE_ASSET__DzQRWl8W__"